<template lang="pug">
  .module__main
    .module__title Список аккаунтов
    .module-content__container
      .add-acc__btn(v-if="isAdmin")
        el-button(@click="startAccountAdd()" :disabled="isAccountEditing") Добавить
      .table__container
        .table-list__container
          el-table(
            v-loading="isLoading"
            :data="formattedAccountsList"
            style="width: 100%; font-size: 12px",
          )
            el-table-column(prop="name" label="Имя" width="150")
              template(v-slot:default="scope")
                span {{ scope.row.name }}
                i.el-icon-success.token-status.color-success(v-if="scope.row.token_valid" title="ТОКЕН ВАЛИДНЫЙ")
                i.el-icon-warning.token-status.color-danger(v-else title="ТОКЕН НЕ ВАЛИДНЫЙ!")
                i.el-icon-view.token-status.account-wallet__btn(title="Показать кошелек аккаунта" @click="showAccountWallet(scope.row.name, scope.row.withdraw_wallet)")
                i.el-icon-money.token-status.account-wallet__btn(title="Показать историю пополнений" @click="activateAccountHistory(scope.row.name)")
            el-table-column(prop="description" label="Описание" width="200")
            el-table-column(label="Баланс" width="200")
              template(v-slot:default="scope")
                .val {{ scope.row.balance }}
                .val {{ `Обновлено: ${scope.row.balance_updated}` }}
            el-table-column(v-if="isAdmin" prop="withdraw_wallet" label="Кошелек вывода" width="200")
            el-table-column(v-if="isAdmin" prop="withdraw_amount" label="Сумма вывода" width="120")
            el-table-column(v-if="isAdmin" prop="min_amount" label="Минимальная сумма" width="150")
            el-table-column(v-if="isAdmin" label="Активен" width="100")
              template(v-slot:default="scope")
                .user-active-change__btn(
                  @click="changeAccountActiveStatus(scope.row)"
                  :class="scope.row.active ? 'active' : 'inactive'"
                )
                  i.el-icon-check.color-success(v-if="scope.row.active")
                  i.el-icon-close.color-danger(v-else)
            el-table-column(v-if="isAdmin" label="Прямой вывод" width="120")
              template(v-slot:default="scope")
                .user-active-change__btn(
                  @click="changeAccountDirectWithdrawStatus(scope.row)"
                  :class="scope.row.withdraw_direct ? 'active' : 'inactive'"
                )
                  i.el-icon-check.color-success(v-if="scope.row.withdraw_direct")
                  i.el-icon-close.color-danger(v-else)
            el-table-column(label="Приоритет" width="100")
              template(v-slot:default="scope")
                .priority__container
                  el-input(v-model="scope.row.priority" type="number" @change="changeAccountPriority(scope.row.name, scope.row.priority)")
            el-table-column(label="Действия" width="200")
              template(v-slot:default="scope")
                .action__buttons
                  .action__btn(v-if="scope.row.withdraw_available")
                    el-button(type="primary" size="mini" @click="activateWithdrawAdd(scope.row.name)") Вывод
                  .action__btn(v-if="isAdmin")
                    el-button(type="primary" size="mini" @click="startAccountEdit(scope.row)") Редактировать
                  .action__btn(v-if="isAdmin")
                    el-button(type="danger" size="mini") Удалить
        .table-pagination__container
          el-pagination(
            style="margin-top: 20px"
            v-if='hasPagination',
            :total='accounts.pagination.count',
            :page-size="per_page",
            :current-page='accounts.pagination.page',
            background,
            layout='prev, pager, next',
            @current-change='loadAccounts',
          )
    el-dialog(:visible.sync="isAccountEditing" :before-close="resetAccountEdit" :title="editingTitle" width="50%")
      .account-edit__container
        .account-edit__fields
          .account-edit__input
            .title Имя
            el-input(v-model="editingAccount.name" placeholder="Имя аккаунта" :disabled="!isNewAccount")
          .account-edit__input
            .title Описание
            el-input(v-model="editingAccount.description" placeholder="Описание аккаунта")
          .account-edit__input
            .title Кошелек для вывода
            el-input(v-model="editingAccount.withdraw_wallet" placeholder="Введите кошелек для вывода")
          .account-edit__input
            .title Сумма для вывода
            el-input(v-model="editingAccount.withdraw_amount" placeholder="Введите сумму для вывода" type="number")
          .account-edit__input
            .title Минимальная сумма на аккаунте
            el-input(v-model="editingAccount.min_amount" placeholder="Введите сумму для вывода" type="number")
          .account-edit__input
            .title
              span Токен
              span.title__details(v-if="!isNewAccount") (оставьте пустым, если не хотите менять)
            el-input(v-model="editingAccount.token" placeholder="Токен авторизации")
          .account-edit__input
            .title
              span Приватный ключ
              span.title__details(v-if="!isNewAccount") (оставьте пустым, если не хотите менять)
            el-input(v-model="editingAccount.private_key" placeholder="Приватный ключ")
        .account-edit__buttons
          el-button(v-if="isNewAccount" type="success" @click="requestAccountAdd") Сохранить
          el-button(v-else type="success" @click="requestAccountEdit") Сохранить
          el-button(type="danger" @click="resetAccountEdit") Отменить
    el-dialog(:visible.sync="isWithdrawsAdding" :before-close="resetWithdrawAdd" title="Добавление вывода" width="50%")
      .account-edit__container
        .account-edit__fields
          .account-edit__input(v-loading="isWalletLoading")
            .title Кошелек
            .wallet-options__container
              .wallet-select__container
                el-select(v-model="selectedWithdrawAccountWallet" @change="selectWithdrawAccountWallet")
                  el-option(v-for="account in accounts.list" :label="account.name" :value="account.wallet" :key="`account-wallet-${account.name}`")
              .wallet-request__btn
                el-button.wallet-request__btn(type="primary" size="mini" icon="el-icon-download" @click="startRequestExternalWallet('kr-pravda')") KR Pravda
            el-input(v-model="withdrawToAdd.wallet" placeholder="Кошелек вывода")
          .account-edit__input
            .title Сумма
            el-input(v-model="withdrawToAdd.amount" placeholder="Сумма вывода" type="number")
          .account-edit__input
            .title Прямой
            el-checkbox(v-model="withdrawToAdd.direct" :disabled="true")
        .account-edit__buttons
          el-button(type="success" @click="startWithdrawAdd") Добавить
          el-button(type="danger" @click="resetWithdrawAdd") Отменить
    el-dialog(:visible.sync="showAccountHistory" :before-close="resetAccountHistory" title="Истоирия аккаунта" width="80%")
      AccountHistory(v-if="showAccountHistory" :account="this.historyAccountName")
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  ADD_ACCOUNT,
  ADD_ACCOUNT_WITHDRAW,
  EDIT_ACCOUNT,
  LOAD_ACCOUNTS_LIST,
  REQUEST_EXTERNAL_WALLET
} from "../../store/const/accounts";
import AccountHistory from "./AccountHistory";

export default {
  name: 'AccountsList',
  components: {
    AccountHistory,
  },
  data() {
    return {
      page: 1,
      per_page: 200,
      intervalHandle: null,
      isFirstLoading: true,
      isAccountEditing: false,
      editingAccount: {
        name: '',
        description: '',
        withdraw_wallet: '',
        withdraw_amount: 0,
        min_amount: 0,
        token: '',
        private_key: '',
      },
      isNewAccount: false,
      isWithdrawsAdding: false,
      withdrawToAdd: {
        name: '',
        wallet: '',
        amount: 0,
        direct: true,
      },
      historyAccountName: '',
      selectedWithdrawAccountWallet: '',
      accountsSortingRules: JSON.parse(localStorage.getItem('rs_accounts_sorting_rules') || '{}'),
    }
  },
  async mounted() {
    await this.loadAccounts();
    this.isFirstLoading = false;
    this.startInterval();
  },
  beforeDestroy() {
    clearInterval(this.intervalHandle);
  },
  computed: {
    ...mapGetters([
      'loading',
      'error',
    ]),
    ...mapGetters('accounts', [
      'accounts',
    ]),
    ...mapGetters('user', [
      'isAdmin',
    ]),
    isLoading() {
      return this.isFirstLoading && this.loading(LOAD_ACCOUNTS_LIST) === 'loading';
    },
    isWalletLoading() {
      return this.loading(REQUEST_EXTERNAL_WALLET) === 'loading';
    },
    isError() {
      return this.loading(LOAD_ACCOUNTS_LIST) === 'error';
    },
    errorMessage() {
      return this.error(LOAD_ACCOUNTS_LIST);
    },
    hasPagination() {
      return this.accounts.pagination.count > this.per_page;
    },
    editingTitle() {
      return this.isNewAccount ? 'Создание аккаунта' : 'Редактирование аккаунта';
    },
    showAccountHistory() {
      return !!this.historyAccountName;
    },
    formattedAccountsList() {
      if (this.accounts.list.length > 0) {
        const accountsList = this.accounts.list.map((account) => {
          return {
            ...account,
            priority: this.accountsSortingRules[account.name] || 0,
          }
        });
        return accountsList.sort((a, b) => b.priority - a.priority);
      } else {
        return this.accounts.list;
      }
    },
  },
  methods: {
    ...mapActions('accounts', {
      loadAccountsList: LOAD_ACCOUNTS_LIST,
      addAccount: ADD_ACCOUNT,
      editAccount: EDIT_ACCOUNT,
      addAccountWithdraw: ADD_ACCOUNT_WITHDRAW,
      requestExternalWallet: REQUEST_EXTERNAL_WALLET,
    }),
    startInterval() {
      this.intervalHandle = setInterval(() => this.loadAccounts(this.page), 10000);
    },
    async loadAccounts(page = 1) {
      if (this.isLoading) {
        return;
      }
      const params = {
        page,
        per_page: this.per_page,
      }
      await this.loadAccountsList({ params });
      this.page = page;
    },
    startAccountEdit(account) {
      this.editingAccount.name = account.name;
      this.editingAccount.description = account.description;
      this.editingAccount.withdraw_wallet = account.withdraw_wallet;
      this.editingAccount.withdraw_amount = account.withdraw_amount;
      this.editingAccount.min_amount = account.min_amount;
      this.isAccountEditing = true;
    },
    resetAccountEdit() {
      this.editingAccount.description = '';
      this.editingAccount.withdraw_wallet = '';
      this.editingAccount.withdraw_amount = 0;
      this.editingAccount.min_amount = 0;
      this.editingAccount.token = '';
      this.editingAccount.private_key = '';
      this.isNewAccount = false;
      this.isAccountEditing = false;
    },
    startAccountAdd() {
      this.isNewAccount = true;
      this.isAccountEditing = true;
    },
    async requestAccountEdit() {
      this.$confirm(
          `Вы уверены, что хотите отредактировать аккаунт?`,
          'Редактирование аккаунта'
      ).then(async () => {
        const body = {
          description: this.editingAccount.description,
          withdraw_wallet: this.editingAccount.withdraw_wallet,
          withdraw_amount: parseFloat(this.editingAccount.withdraw_amount) || 0,
          min_amount: parseFloat(this.editingAccount.min_amount) || 0,
        };
        if (this.editingAccount.token) {
          body.token = this.editingAccount.token;
        }
        if (this.editingAccount.private_key) {
          body.private_key = this.editingAccount.private_key;
        }
        const request = await this.editAccount({ name: this.editingAccount.name, body });
        if (request.success) {
          this.$message.success('Аккаунт успешно изменен');
          this.loadAccounts();
          this.resetAccountEdit();
        } else {
          this.$message.error(`Ошибка редактирования аккаунта: ${request.message || 'Неизвестная ошибка'}`);
        }
      }).catch(() => {
        this.$message.info('Изменение аккаунта отменено');
      });

    },
    async requestAccountAdd() {
      const request = await this.addAccount(this.editingAccount);
      if (request.success) {
        this.$message.success('Аккаунт успешно добавлен');
        this.loadAccounts();
        this.resetAccountEdit();
      } else {
        this.$message.error(`Ошибка добавления аккаунта: ${request.message || 'Неизвестная ошибка'}`);
      }
    },
    async changeAccountActiveStatus(account) {
      this.$confirm(
          `Вы уверены, что хотите ${account.active ? 'деактивировать' : 'активировать'} пользователя?`,
          'Изменение пользователя'
      ).then(async () => {
        const request = await this.editAccount({ name: account.name, body: { active: !account.active } });
        if (request.success) {
          this.$message.success('Аккаунт успешно изменен');
          this.loadAccounts();
        } else {
          this.$message.error(`Ошибка редактирования аккаунта: ${request.message || 'Неизвестная ошибка'}`);
        }
      }).catch(() => {
        this.$message.info('Изменение аккаунта отменено');
      });
    },
    async changeAccountDirectWithdrawStatus(account) {
      this.$confirm(
          `Вы уверены, что хотите ${account.active ? 'деактивировать' : 'активировать'} прямой вывод?`,
          'Изменение пользователя'
      ).then(async () => {
        const request = await this.editAccount({ name: account.name, body: { withdraw_direct: !account.withdraw_direct } });
        if (request.success) {
          this.$message.success('Аккаунт успешно изменен');
          this.loadAccounts();
        } else {
          this.$message.error(`Ошибка редактирования аккаунта: ${request.message || 'Неизвестная ошибка'}`);
        }
      }).catch(() => {
        this.$message.info('Изменение аккаунта отменено');
      });
    },
    activateWithdrawAdd(name) {
      this.withdrawToAdd.name = name;
      this.isWithdrawsAdding = true;
    },
    resetWithdrawAdd() {
      this.withdrawToAdd.name = '';
      this.withdrawToAdd.wallet = '';
      this.withdrawToAdd.amount = 0;
      this.withdrawToAdd.direct = true;
      this.isWithdrawsAdding = false;
    },
    async startWithdrawAdd() {
      if (!this.withdrawToAdd.amount || this.withdrawToAdd < 0) {
        return this.$message.warning('Неверная сумма вывода')
      }
      if (!this.withdrawToAdd.wallet) {
        return this.$message.warning('Не указан кошелек для вывода')
      }
      this.$confirm(
          `Вы уверены, что хотите добавить вывод?`,
          'Добавление вывода'
      ).then(async () => {
        const request = await this.addAccountWithdraw(this.withdrawToAdd);
        if (request.success) {
          this.$message.success('Вывод успешно добавлен');
          await this.$router.push('withdraws');
        } else {
          this.$message.error(`Ошибка добавления вывода: ${request.message || 'Неизвестная ошибка'}`);
        }
      }).catch(() => {
        this.$message.info('Добавление вывода отменено');
      });
    },
    async startRequestExternalWallet(source) {
      const request = await this.requestExternalWallet(source);
      if (request.success) {
        this.withdrawToAdd.wallet = request.data;
      } else {
        this.$message.error(`Ошибка получения кошелька: ${request.message || 'Неизвестная ошибка'}`);
      }
    },
    showAccountWallet(account, wallet) {
      this.$alert(`Кошелек аккаунта ${account}: ${wallet}`, 'Кошелек', {
        confirmButtonText: 'OK',
      }).catch(() => {});
    },
    activateAccountHistory(account) {
      this.historyAccountName = account;
    },
    resetAccountHistory() {
      this.historyAccountName = '';
    },
    selectWithdrawAccountWallet() {
      this.withdrawToAdd.wallet = this.selectedWithdrawAccountWallet;
    },
    changeAccountPriority(name, priority) {
      if (priority === '0') {
        delete this.accountsSortingRules[name];
      } else {
        this.accountsSortingRules[name] = parseInt(priority);
      }
      localStorage.setItem('rs_accounts_sorting_rules', JSON.stringify(this.accountsSortingRules));
    },
  }
};
</script>
<style>
  .add-acc__btn {
    margin-bottom: 5px;
  }

  .action__btn {
    margin: 2px auto;
  }

  .action__btn button {
    width: 100%;
  }

  .title__details {
    margin-left: 5px;
  }

  .account-edit__input {
    margin-bottom: 10px;
  }

  .account-edit__input .title {
    margin-bottom: 5px;
  }

  .user-active-change__btn i {
    cursor: pointer;
    font-size: 16px;
  }

  .token-status {
    margin-left: 5px;
    font-size: 16px;
    font-weight: bold;
  }

  .wallet-options__container {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
  }

  .wallet-request__btn {
    margin-bottom: 2px;
    margin-left: 5px;
  }

  .account-wallet__btn {
    cursor: pointer;
  }

  .account-wallet__btn:hover {
    color: #505dc3;
  }
</style>
